<div class="page-layout-container">
    <div class="title-group">
        <h1> Manage Employee Access </h1>
    </div>
    <div *ngIf="successFlag" class="alert alert-success">{{ message }}</div>
    <div [formGroup]="userForm" class="page-layout-container">
        <div class="row">
            <div class="col" style="width: 30%;">
                <app-active-emp [filterEmpName]="filterEmpName" (empName)="empNameSelected($event)">
                </app-active-emp>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="example-full-width">
                    <mat-label>Generate Password </mat-label>
                    <input type="text" matInput formControlName="password">
                </mat-form-field>
                <button mat-button (click)="generateRandomPD()" type="submit">Generate Password
                </button>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <mat-form-field class="example-full-width">
                    <mat-label>Status </mat-label>
                    <select matNativeControl required formControlName="active">
                        <option value="active">Active</option>
                        <option value="inActive">In Active</option>
                    </select>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="example-full-width">
                    <mat-label>Role </mat-label>
                    <input type="text" matInput formControlName="role" value="Employee" readonly="true">
                </mat-form-field>
            </div>
        </div>
        <div style="text-align: center">
            <button mat-button [disabled]="!userForm.valid" (click)="createUser()" type="submit">Manage Employee
                Access
            </button>
        </div>
    </div>
</div>